module.exports = __webpack_public_path__ + "media/bootstrap-icons/eyedropper-08cbde7f.svg";